<template>
  <!-- 党史人物查看更多二级页 -->
  <div>
    <div class="dsxxpage-content">
      <!--面包屑-->
      <div class="breadcrumb">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>党史学习</el-breadcrumb-item>
          <el-breadcrumb-item>党史人物</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <!--内容-->
      <div class="dsxxpage-cont">
        <div class="dsxxpage-tit">党史人物</div>
        <el-tabs v-model="activeName" :tab-position="tabPosition" @tab-click="handleClick">
          <el-tab-pane :name="i.toString()" v-for="(item,i) in historyMembers" :key="item.id">
            <span slot="label">{{ item.columnName }}</span>
            <ul class="dsxxpage-leader" v-loading="loading">
              <li v-for="(item, index) in list" :key="index">
                <a :href="`/#/DsxxXqy/${type}/${activeName}/${index}/${uidList[index]}`" target="_blank">
                  <img :src="item.src" />
                  <span>{{ item.name }}</span>
                </a>
              </li>
            </ul>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </div>
</template>

<script>
import { mixin } from "../mixins/mixin";
export default {
  mixins: [mixin],
  data() {
    return {
      a: 1,
      tabPosition: "left",
      activeName:'',
      list:[],
      lxImgArr: [
        { imgUrl: "./img/dsxxpage/lx-pic1.png", name: "毛泽东", id: "1" },
        { imgUrl: "./img/dsxxpage/lx-pic2.png", name: "周恩来" },
        { imgUrl: "./img/dsxxpage/lx-pic3.png", name: "刘少奇" },
        { imgUrl: "./img/dsxxpage/lx-pic4.png", name: "朱德" },
        { imgUrl: "./img/dsxxpage/lx-pic5.png", name: "邓少平" },
        { imgUrl: "./img/dsxxpage/lx-pic6.png", name: "陈云" },
      ],
      yxImgArr: [
        { imgUrl: "./img/dsxxpage/yx/yx_pic1.png", name: "任弼时" },
        { imgUrl: "./img/dsxxpage/yx/yx_pic2.png", name: "董必武" },
        { imgUrl: "./img/dsxxpage/yx/yx_pic3.png", name: "邓颖超" },
        { imgUrl: "./img/dsxxpage/yx/yx_pic4.png", name: "习仲勋" },
        { imgUrl: "./img/dsxxpage/yx/yx_pic5.png", name: "王震" },
        { imgUrl: "./img/dsxxpage/yx/yx_pic6.png", name: "彭真" },
        { imgUrl: "./img/dsxxpage/yx/yx_pic7.png", name: "陶铸" },
        { imgUrl: "./img/dsxxpage/yx/yx_pic8.png", name: "谭震林" },
        { imgUrl: "./img/dsxxpage/yx/yx_pic9.png", name: "薄一波" },
        { imgUrl: "./img/dsxxpage/yx/yx_pic10.png", name: "李先念" },
        { imgUrl: "./img/dsxxpage/yx/yx_pic11.png", name: "杨尚昆" },
        { imgUrl: "./img/dsxxpage/yx/yx_pic12.png", name: "宋任穷" },
        { imgUrl: "./img/dsxxpage/yx/yx_pic13.png", name: "廖承志" },
        { imgUrl: "./img/dsxxpage/yx/yx_pic14.png", name: "谷牧" },
        { imgUrl: "./img/dsxxpage/yx/yx_pic15.png", name: "丁关根" },
      ],
      jsImgArr: [
        { imgUrl: "./img/dsxxpage/js/js_pic1.png", name: "朱德" },
        { imgUrl: "./img/dsxxpage/js/js_pic2.png", name: "彭德怀" },
        { imgUrl: "./img/dsxxpage/js/js_pic3.png", name: "刘伯承" },
        { imgUrl: "./img/dsxxpage/js/js_pic4.png", name: "贺龙" },
        { imgUrl: "./img/dsxxpage/js/js_pic5.png", name: "陈毅" },
        { imgUrl: "./img/dsxxpage/js/js_pic6.png", name: "罗荣桓" },
        { imgUrl: "./img/dsxxpage/js/js_pic7.png", name: "徐向前" },
        { imgUrl: "./img/dsxxpage/js/js_pic8.png", name: "聂荣臻" },
        { imgUrl: "./img/dsxxpage/js/js_pic9.png", name: "叶剑英" },
        { imgUrl: "./img/dsxxpage/js/js_pic10.png", name: "粟裕" },
        { imgUrl: "./img/dsxxpage/js/js_pic11.png", name: "徐海东" },
        { imgUrl: "./img/dsxxpage/js/js_pic12.png", name: "黄克诚" },
        { imgUrl: "./img/dsxxpage/js/js_pic13.png", name: "陈赓" },
        { imgUrl: "./img/dsxxpage/js/js_pic14.png", name: "谭政" },
        { imgUrl: "./img/dsxxpage/js/js_pic15.png", name: "萧劲光" },
        { imgUrl: "./img/dsxxpage/js/js_pic16.png", name: "张云逸" },
        { imgUrl: "./img/dsxxpage/js/js_pic17.png", name: "罗瑞卿" },
        { imgUrl: "./img/dsxxpage/js/js_pic18.png", name: "王树声" },
        { imgUrl: "./img/dsxxpage/js/js_pic19.png", name: "许光达" },
      ],
      xbImgArr: [
        { imgUrl: "./img/dsxxpage/xb/xb_pic1.png", name: "毛岸英" },
        { imgUrl: "./img/dsxxpage/xb/xb_pic2.png", name: "瞿秋白" },
        { imgUrl: "./img/dsxxpage/xb/xb_pic3.png", name: "李大钊" },
        { imgUrl: "./img/dsxxpage/xb/xb_pic4.png", name: "方志敏" },
        { imgUrl: "./img/dsxxpage/xb/xb_pic5.png", name: "江上青" },
        { imgUrl: "./img/dsxxpage/xb/xb_pic6.png", name: "彭雪枫" },
        { imgUrl: "./img/dsxxpage/xb/xb_pic7.png", name: "王若飞" },
        { imgUrl: "./img/dsxxpage/xb/xb_pic8.png", name: "黄继光" },
        { imgUrl: "./img/dsxxpage/xb/xb_pic9.png", name: "陈潭秋" },
        { imgUrl: "./img/dsxxpage/xb/xb_pic10.png", name: "张思德" },
        { imgUrl: "./img/dsxxpage/xb/xb_pic11.png", name: "董必武" },
        { imgUrl: "./img/dsxxpage/xb/xb_pic12.png", name: "林伯渠" },
        { imgUrl: "./img/dsxxpage/xb/xb_pic13.png", name: "蔡和森" },
        { imgUrl: "./img/dsxxpage/xb/xb_pic14.png", name: "董存瑞" },
        { imgUrl: "./img/dsxxpage/xb/xb_pic15.png", name: "高君宇" },
        { imgUrl: "./img/dsxxpage/xb/xb_pic16.png", name: "毛泽民" },
        { imgUrl: "./img/dsxxpage/xb/xb_pic17.png", name: "黄公略" },
        { imgUrl: "./img/dsxxpage/xb/xb_pic18.png", name: "刘志丹" },
        { imgUrl: "./img/dsxxpage/xb/xb_pic19.png", name: "彭明治" },
        { imgUrl: "./img/dsxxpage/xb/xb_pic20.png", name: "彭湃" },
      ],
    };
  },
  created(){
    this.activeName = this.$route.params.activeName
    this.list = this.leaderList[Number(this.activeName)]
  },
  methods: {
    handleClick(val) {
      this.type = this.historyMembers[Number(val.index)].columnName
      this.list = this.leaderList[Number(val.index)]
      this.getUidList()
    },
  },
};
</script>

<style  lang="scss" scoped>
.dsxxpage-content {
  width: 1200px;
  height: auto;
  margin: 30px auto;
  margin-bottom: 70px;
  .breadcrumb {
    position: relative;
    box-sizing: border-box;
    padding-left: 20px;
    .el-breadcrumb {
      font-size: 16px;
    }
  }
  .breadcrumb:before {
    content: "";
    position: absolute;
    left: 0;
    display: inline-block;
    width: 17px;
    height: 16px;
    background: url("../assets/images/dzdgpage_arr.png") no-repeat;
  }
  .dsxxpage-cont {
    position: relative;
    height: auto;
    margin-top: 20px;
    .dsxxpage-tit {
      position: absolute;
      z-index: 10;
      top: 0;
      left: -6px;
      width: 232px;
      height: 51px;
      text-align: center;
      line-height: 51px;
      font-size: 18px;
      color: #f9fdcc;
      background: url("../assets/images/dsxxpage-tit.png") no-repeat;
    }
     :deep(.el-tabs--left .el-tabs__header.is-left) {
      width: 220px;
      box-sizing: border-box;
      padding-top: 58px;
      height: 304px;
      background: #fff8f8;
      border: 1px solid #fae0e0;
    }
     :deep(.el-tabs__item) {
      width: 220px;
      text-align: center;
      line-height: 50px;
      height: 50px;
      margin-top: 8px;
      font-size: 16px;
      letter-spacing: 1px;
      // color: #383636;
      background: url("../assets/images/zsxxleft-bg.png") no-repeat center;
    }
     :deep(.el-tabs__item:hover) {
      color: #de1c26;
    }
     :deep(.el-tabs__item.is-active) {
      color: #fff;
      background: url("../assets/images/zsxxlf-active.png") no-repeat center;
    }
     :deep(.el-tabs__active-bar) {
      display: none;
    }
    .dsxxpage-leader {
      display: flex;
      flex-wrap: wrap;
      height: auto;
      margin-left: 60px;
      li {
        width: 20%;
        a{
          width: 139px;
        }
        span {
          display: inline-block;
          width: 139px;
          margin-top: 8px;
          text-align: center;
          font-size: 16px;
          margin-bottom: 25px;
        }
      }
    }
  }
}
</style>